import * as React from 'react';
import { __ } from 'react-i18n';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';

export interface Props {
  name: string;
  imgSrc: string;
  url: string;
}

function HomepageCategoryLink({ name, imgSrc, url }: Props) {
  return (
    <Wrapper>
      <ImageNameWrapper to={url}>
        <Image alt={`Obrázok kategórie ${name}`} src={imgSrc} />
        <Name>{`${name}`}</Name>
      </ImageNameWrapper>
      <StyledLink to={url}>{__(`Viac`)}</StyledLink>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  background: ${({ theme }) => theme.color.backgroundDark};
  margin-bottom: ${rem(16)};
  margin-right: ${rem(32)};
  justify-content: space-between;
  padding: ${rem(16)};
  height: ${rem(80)};

  &:last-child {
    margin-right: 0;
  }

  ${({ theme }) => theme.mediab.l925`
    margin-right: 0;
  `}
`;

const ImageNameWrapper = styled(Link)`
  display: flex;
  flex-flow: row;
  align-items: center;
  width: 65%;
  margin-right: ${rem(32)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;

  ${({ theme }) => theme.mediab.l1150`
    margin-right: ${rem(8)};
  `}
`;

const Image = styled.img`
  width: ${rem(56)};
  height: ${rem(56)};
  margin-right: ${rem(16)};
`;

const Name = styled(TextP)`
  font-family: ${({ theme }) => theme.font.secondary};
  font-size: ${rem(20)};
  font-weight: 500;
  text-transform: uppercase;
  line-height: ${rem(22)};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ theme }) => theme.mediab.s450`
    max-width: ${rem(130)};
  `}
`;

const StyledLink = styled(Link)`
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.color.textPrimary};
  font-weight: 700;
  padding-right: ${rem(16)};
`;

export { HomepageCategoryLink };
